import $ from 'jquery'
import * as d3 from 'd3'
// import down1 from '../../assets/imgs/priceIndex/down1.png'
// import down2 from '../../assets/imgs/priceIndex/down2.png'
// import down3 from '../../assets/imgs/priceIndex/down3.png'
// import down4 from '../../assets/imgs/priceIndex/down4.png'
// import down5 from '../../assets/imgs/priceIndex/down5.png'
// import down6 from '../../assets/imgs/priceIndex/down6.png'
// import down7 from '../../assets/imgs/priceIndex/down7.png'
// import down8 from '../../assets/imgs/priceIndex/down8.png'
// import up1 from '../../assets/imgs/priceIndex/up1.png'
// import up2 from '../../assets/imgs/priceIndex/up2.png'
// import up3 from '../../assets/imgs/priceIndex/up3.png'
// import up4 from '../../assets/imgs/priceIndex/up4.png'
// import up5 from '../../assets/imgs/priceIndex/up5.png'
// import up6 from '../../assets/imgs/priceIndex/up6.png'
// import up7 from '../../assets/imgs/priceIndex/up7.png'
// import up8 from '../../assets/imgs/priceIndex/up8.png'
window.createjs = {}
createjs.tweenjs = require('./tweenjs-0.6.2.min')
!(function(t, e) {
  if ('object' == typeof exports && 'object' == typeof module) module.exports = e()
  else if ('function' == typeof define && define.amd) define([], e)
  else {
    var r = e()
    for (var n in r) ('object' == typeof exports ? exports : t)[n] = r[n]
  }
})(this, function() {
  return (function(t) {
    function e(n) {
      if (r[n]) return r[n].exports
      var a = (r[n] = { exports: {}, id: n, loaded: !1 })
      return t[n].call(a.exports, a, a.exports, e), (a.loaded = !0), a.exports
    }

    var r = {}
    return (e.m = t), (e.c = r), (e.p = ''), e(0)
  })([
    function(t, e, r) {
      //t.exports = r(1)
      e.default = r(1)
    },
    function(t, e) {
      var r = -40,
        n = 315,
        a = 210,
        o = 1e3,
        i = 800
      t.exports = function(t) {
        function e(t) {
          // return 'translate(' + 20 * t + ',' + 20 * t + ')scale(' + t + ')'
          var scale = parseInt(d3.select('#TreeAnalysis').style('height'))/660
          return 'translate(' + 50 + ',' + 0 + ')scale('+scale+')'
        }

        var l = t,
          c = null,
          u = 1,
          f = {},
          p = parseInt(d3.select('#TreeAnalysis').style('width')),
          d = parseInt(d3.select('#TreeAnalysis').style('height')),
          s = function(t, e) {
            var r = ''
            null != e.frontSign && (r = e.frontSign)
            var n = { t: -1 }
            createjs.Tween.get(n, {
              loop: !1,
              onChange: function() {
                n.t > 0 && t.text(r + (e.value * n.t).toFixed(e.dicimal))
              }
            })
              .to({ t: 0 }, e.delay)
              .to({ t: 1 }, e.times)
          },
          x = function(t, e) {
            // var r = 0
            // setInterval(function() {
            //   t.attr('xlink:href', function(t) {
            //     return e.item[r]
            //   }),
            //     r++,
            //     r == e.item.length && (r = 0)
            // }, e.time)
          },
          y = function(t, e) {
            e > 0
              ? x(t, {
                  time: 140,
                  // item: [up1, up2, up3, up4, up5, up6, up7, up8]
                })
              : e < 0 &&
                x(t, {
                  time: 140,
                  // item: [down1, down2, down3, down4, down5, down6, down7, down8]
                })
          },
          g = function(t, e) {
            var r = '#8abe32',
              n = ''
            e.allPercentage > 0
              ? ((r = '#d34d4d'), (n = '+'))
              : 0 == e.allPercentage && ((r = '#000'), (n = '+'))
            var a = t.append('g').attr('opacity', 0)
            a
              .append('path')
              .attr('d', 'M 40 60 H 400 V 150 H 40 Z')
              .attr('fill', 'none')
              .attr('stroke', '#66ebc2')
              // a
                // .append('path')
                // .attr('d', 'M 52 72 H 388 V 138 H 52 Z')
                // .attr('fill', 'rgb(0,12,27)')
                // .attr('stroke', 'rgb(48,234,137)')
            var o = a
              .append('text')
              .attr('dx', function(t) {
                return 220
              })
              .attr('dy', function(t) {
                return 123
              })
              .attr('font-size', '48px')
              .attr('font-family', '微软雅黑')
              .attr('fill', r)
              .attr('font-weight', 'bold')
              .style('text-anchor', function(t) {
                return 'middle'
              })
              .text(0)
            s(o, { value: e.combinedIndex, times: 200, dicimal: 2, delay: 0 }),
              a
                .append('text')
                .attr('dx', function(t) {
                  return 40
                })
                .attr('dy', function(t) {
                  return 40
                })
                .attr('font-size', '30px')
                .attr('font-family', '微软雅黑')
                .attr('fill', '#66ebc2')
                .style('text-anchor', function(t) {
                  return 'left'
                })
                .text('药品价格指数')
            var l = a
              .append('text')
              .attr('dx', function(t) {
                return 280
              })
              .attr('dy', function(t) {
                return 40
              })
              .attr('font-size', '30px')
              .attr('font-family', '微软雅黑')
              .attr('fill', r)
              .style('text-anchor', function(t) {
                return 'left'
              })
              .text('0%')
            s(l, { value: e.allPercentage, times: 200, dicimal: 2, delay: 0, frontSign: n })
            var c = a
              .append('image')
              .attr('x', 250)
              .attr('y', 17)
              .attr('width', function(t) {
                return 28
              })
              .attr('height', function(t) {
                return 28
              })
            y(c, e.allPercentage),
              a
                .append('text')
                .attr('dx', function(t) {
                  return 40
                })
                .attr('dy', function(t) {
                  return 0
                })
                .attr('font-size', '18px')
                .attr('font-family', '微软雅黑')
                .attr('fill', '#66ebc2')
                .style('text-anchor', function(t) {
                  return 'left'
                })
                // .text(e.date),
              a
                .transition()
                .duration(i)
                .attr('opacity', 1)
          },
          m = function(t, e, a, o) {
            var l = '',
              c = '#66ebc2'
            a.percentage > 0 ? ((c = '#66ebc2'), (l = '+')) : 0 == a.percentage && ((c = o.color), (l = '+'))
            var u = t
              .append('g')
              .attr('transform', 'translate(0,' + (r + n * e) + ')')
              .attr('opacity', 0)
            u
              .append('path')
              .attr('d', 'M32 75 238 75')
              .attr('fill', 'none')
              .attr('stroke', '#66ebc2')
              // u
              //   .append('path')
              //   .attr('d', 'M 48 58 H 232 V 92 H 48 Z')
              //   .attr('fill', 'rgb(0,12,27)')
              //   .attr('stroke', o.color)
            var f = u
              .append('text')
              .attr('dx', function(t) {
                return 140
              })
              .attr('dy', function(t) {
                return 86
              })
              .attr('font-size', '30px')
              .attr('font-family', '微软雅黑')
              .attr('font-weight', 'bold')
              .attr('fill', "#8abe32")
              .style('text-anchor', function(t) {
                return 'middle'
              }).style('display','none')
              .text(0)
            s(f, { value: a.index, times: 200, dicimal: 2, delay: 200 }),
              u
                .append('text')
                .attr('dx', function(t) {
                  return 40
                })
                .attr('dy', function(t) {
                  return 35
                })
                .attr('font-size', '24px')
                .attr('font-family', '微软雅黑')
                .attr('fill', o.color)
                .style('text-anchor', function(t) {
                  return 'left'
                }).style('display','none')
                .text('价格指数')
            var p = u
                .append('text')
                .attr('dx', function(t) {
                  return 190
                })
                .attr('dy', function(t) {
                  return 35
                })
                .attr('font-size', '24px')
                .attr('font-family', '微软雅黑')
                .attr('fill', "#8abe32")
                .style('text-anchor', function(t) {
                  return 'left'
                }).style('display','none')
                .text('0%'),
              d = u
                .append('image')
                .attr('x', 155)
                .attr('y', 14)
                .attr('width', function(t) {
                  return 28
                })
                .attr('height', function(t) {
                  return 28
                })
            y(d, a.percentage),
              s(p, {
                value: a.percentage,
                times: 200,
                dicimal: 2,
                delay: 200,
                frontSign: l
              }),
              u
                .append('text')
                .attr('dx', function(t) {
                  return 40
                })
                .attr('dy', function(t) {
                  return 0
                })
                .attr('font-size', '18px')
                .attr('font-family', '微软雅黑')
                .attr('fill', o.color)
                .style('text-anchor', function(t) {
                  return 'left'
                }).style('display','none')
                .text(o.name),
              u
                .transition()
                .delay(200)
                .duration(i)
                .attr('opacity', 1),
              h(t, e, a, o)
          },
          h = function(t, e, i, l) {
            for (var c = [], u = [], f = 0; f < i.item.length; f++)
              i.item[f].percentage >= 0 ? c.push(i.item[f]) : u.push(i.item[f])
            c.sort(function(t, e) {
              return e.percentage - t.percentage
            }),
              u.sort(function(t, e) {
                return t.percentage - e.percentage
              })
            var p = 1
            c.length > p && (p = c.length), u.length > p && (p = u.length)
            var d = 320 + p * a
            w(t, [{ x: 240, y: r + n * e + 75 }, { x: d, y: r + n * e + 75 }], {
              times: o,
              color: l.color,
              delay: 300
            }),
              v(t, { x: d, y: r + n * e + 75, r: 4, color:  l.color, delay: 4e3 })
            for (var f = 0; f < c.length; f++) {
              var s = 340 + a * f,
                x = r + n * e - 50 + 15 * f,
                y = ((s - 240) / d) * o
              w(t, [{ x: s - 100, y: r + n * e + 75 }, { x: s - 100, y: x - 20 }], {
                times: o - y,
                color:  l.color,
                delay: 300 + y
              }),
                v(t, { x: s - 100, y: x - 20, r: 4, color:  l.color, delay: 4e3 }),
                b(t, c[f], l, {
                  delay: 300 + y,
                  x: s,
                  y: x,
                  color: '#d34d4d',
                  sign: '+'
                })
            }
            for (var f = 0; f < u.length; f++) {
              var s = 400 + a * f,
                x = r + n * e + 200 - 15 * f,
                y = ((s - 240) / d) * o
              w(t, [{ x: s - 100, y: r + n * e + 75 }, { x: s - 100, y: x + 20 }], {
                times: o - y,
                color: l.color,
                delay: 300 + y
              }),
                v(t, { x: s - 100, y: x + 20, r: 4, color:l.color, delay: 4e3 }),
                b(t, u[f], l, {
                  delay:300+y,
                  x: s,
                  y: x - 55,
                  color: "#8abe32",
                  sign: ''
                })
            }
          },
          v = function(t, e) {
            t.append('circle')
              .attr('cx', e.x)
              .attr('cy', e.y)
              .attr('fill', e.color)
              .attr('r', e.r)
              .attr('opacity', 0)
              .transition()
              .delay(500)
              .duration(100)
              .attr('opacity', 1)
          },
          b = function(t, e, r, n) {
            var a = n.color
            0 == e.percentage && (a = r.color)
            var o = t
              .append('g')
              .attr('transform', 'translate(' + n.x + ',' + n.y + ')')
              .attr('opacity', 0)
            o
              .append('text')
              .attr('dx', function(t) {
                return -90
              })
              .attr('dy', function(t) {
                return 0
              })
              .attr('font-size', '18px')
              .attr('font-family', '微软雅黑')
              .attr('fill', "#66ebc2")
              .style('text-anchor', function(t) {
                return 'left'
              })
              .text(e.name),
              o
                .append('text')
                .attr('dx', function(t) {
                  return -90
                })
                .attr('dy', function(t) {
                  return 24
                })
                .attr('font-size', '18px')
                .attr('font-family', '微软雅黑')
                .attr('fill', '#66ebc2')
                .style('text-anchor', function(t) {
                  return 'left'
                })
                .text('价格指数')
            var l = o
              .append('text')
              .attr('dx', function(t) {
                return 3
              })
              .attr('dy', function(t) {
                return 24
              })
              .attr('font-size', '18px')
              .attr('font-family', '微软雅黑')
              .attr('fill', a)
              .style('text-anchor', function(t) {
                return 'left'
              })
              .text('0%')
            s(l, { value: e.percentage, times: 200, dicimal: 2, delay: n.delay, frontSign: n.sign })
            var c = o
              .append('image')
              .attr('x', 83)
              .attr('y', 9)
              .attr('width', function(t) {
                return 18
              })
              .attr('height', function(t) {
                return 18
              })
            y(c, e.percentage)
            var u = o
              .append('text')
              .attr('dx', function(t) {
                return -90
              })
              .attr('dy', function(t) {
                return 74
              })
              .attr('font-size', '30px')
              .attr('font-family', '微软雅黑')
              .attr('fill', a)
              .attr('font-weight', 'bold')
              .style('text-anchor', function(t) {
                return 'left'
              })
              .text(0)
            s(u, {
              value: e.index,
              times: 200,
              dicimal: 2,
              delay: n.delay
            }),
              o
                .transition()
                .delay(n.delay)
                .duration(i)
                .attr('opacity', 1)
          },
          w = function(t, e, r) {
            for (var n = t.append('g'), a = 0, o = [], i = [], l = 1; l < e.length; l++) {
              var c = Math.abs(e[l].x - e[l - 1].x),
                u = Math.abs(e[l].y - e[l - 1].y),
                f = Math.sqrt(Math.pow(c, 2) + Math.pow(u, 2))
              ;(a += f), o.push(f)
            }
            for (var l = 0; l < o.length; l++) i.push((r.times * o[l]) / a)
            var p = 0
            null != r.delay && (p = r.delay)
            for (var l = 0; l < o.length; l++)
              n
                .append('line')
                .attr({
                  x1: e[l].x,
                  y1: e[l].y,
                  x2: e[l].x,
                  y2: e[l].y
                })
                .attr('stroke-width', 1)
                .attr('stroke', '#66ebc2')
                .transition()
                .ease('linear')
                .delay(p)
                .duration(i[l])
                .attr({
                  x1: e[l].x,
                  y1: e[l].y,
                  x2: e[l + 1].x,
                  y2: e[l + 1].y
                }),
                (p += i[l])
          }
        return {
          init: function() {
            c = d3
              .select(l)
              .append('svg')
              .attr('width', p)
              .attr('height', d)
          },
          dispose: function() {},
          show: function(t) {
            if (1 != $(l).is(':hidden')) {
              ;(f = t), c.selectAll('g').remove()
              var a = c.append('g').attr('transform', 'translate(20,20)')
              g(a, f),
                m(a, 1, f.basket, {
                  color: '#66ebc2',
                  name: '抗生素价格指数'
                }),
                // m(a, 2, f.grainOil, { color: 'rgb(64,176,252)', name: '抗生素' }),
                // m(a, 3, f.eo, { color: 'rgb(64,176,256)', name: '第三序列' }),
                w(
                  a,
                  [
                    { x: 40, y: 105 },
                    {
                      x: 32,
                      y: 105
                    },
                    { x: 32, y: r + n + 75 }
                  ],
                  { times: o, color: '#08a7df' }
                ),
                // w(
                //   a,
                //   [
                //     { x: 32, y: r + n + 75 },
                //     {
                //       x: 40,
                //       y: r + n + 75
                //     }
                //   ],
                //   { times: o, color: '#025787', delay: o }
                // ),
                // w(
                //   a,
                //   [
                //     { x: 32, y: r + n + 75 },
                //     { x: 32, y: r + 2 * n + 75 },
                //     {
                //       x: 40,
                //       y: r + 2 * n + 75
                //     }
                //   ],
                //   { times: o, color: '#025787', delay: o }
                // ),
                // w(
                //   a,
                //   [
                //     { x: 32, y: r + n + 75 },
                //     { x: 32, y: r + 3 * n + 75 },
                //     {
                //       x: 40,
                //       y: r + 3 * n + 75
                //     }
                //   ],
                //   { times: o, color: '#025787', delay: o }
                // ),
                c.select('g').attr('transform', e(u))
            }
          },
          hide: function() {},
          // rescale: function(param) {
          //   c.attr('transfrom', 'scale(' + param + ')')
          // },
          resize: function(t, r, n) {
            ;(u = t), c.select('g').attr('transform', e(t))
          }
        }
      }
    }
  ])
})



// WEBPACK FOOTER //
// ./src/components/tree-analysis/TreeAnalysisChart.min.js